import {useEffect, useRef} from "react";

const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

let scriptPromise = null;

function loadTurnstileScript() {
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = SCRIPT_SRC;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = () => {
                scriptPromise = null;
                reject(new Error("Could not load Turnstile"));
            };
            document.head.appendChild(script);
        });
    }
    return scriptPromise;
}

// Renders a Cloudflare Turnstile widget and reports the token (or "" when it
// expires/errors) through onToken. onError fires if the Cloudflare script cannot
// load at all (blocked network, ad blocker). Reset after a failed submit with
// window.turnstile.reset().
function Turnstile({siteKey, onToken, onError}) {

    const containerRef = useRef(null);
    const onTokenRef = useRef(onToken);
    onTokenRef.current = onToken;
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;

    useEffect(() => {
        let widgetId = null;
        let cancelled = false;
        loadTurnstileScript()
            .then(() => {
                if (cancelled || !containerRef.current || !window.turnstile) {
                    return;
                }
                widgetId = window.turnstile.render(containerRef.current, {
                    sitekey: siteKey,
                    callback: (token) => onTokenRef.current(token),
                    "expired-callback": () => onTokenRef.current(""),
                    "error-callback": () => onTokenRef.current(""),
                });
            })
            .catch((error) => {
                console.error("Could not load captcha:", error);
                if (!cancelled && onErrorRef.current) {
                    onErrorRef.current();
                }
            });
        return () => {
            cancelled = true;
            if (widgetId !== null && window.turnstile) {
                window.turnstile.remove(widgetId);
            }
        };
    }, [siteKey]);

    return <div ref={containerRef}/>;
}

export default Turnstile;
